<template>
  <v-dialog v-model="dialog" width="800" scrollable>
    <v-card flat>
      <v-card-title class="pa-0">
        <v-toolbar flat dark color="secondary">
          <v-toolbar-title>Unggah {{ title }}</v-toolbar-title>
          <v-spacer />
          <v-btn right icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="mt-5">
        <v-row class="px-3">
          <v-col cols="12" sm="12" class="px-0">
            <span :class="[`px-0 body-2 secondary--text`]" style="height: 24px">
              Judul Berkas <span class="red--text">*</span>
            </span>
            <v-text-field
              v-model="berkas.judul"
              placeholder="Tuliskan judul berkas"
              outlined
              single-line
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="12" class="px-0">
            <span class="secondary--text">File Berkas <span class="red--text">*</span></span>
            <v-file-input
              v-model="berkas.file"
              placeholder="Pilih berkas yang ingin diunggah"
              :accept="['application/pdf,image/*']"
              outlined
              dense
              hide-details
              prepend-icon=""
              @click:append="onHandleClickAppend"
              :ref="`vFileInput`"
              append-icon="mdi-paperclip"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions class="px-6">
        <v-spacer></v-spacer>
        <div class="text-right">
          <v-btn class="mr-2" color="grey" elevation="0" right text dark @click="close">
            <div class="grey--text">Batal</div>
          </v-btn>
          <v-btn
            color="secondary"
            elevation="0"
            @click="onSave"
            :disabled="!berkas.judul || !berkas.file || loading"
            :loading="loading"
          >
            Simpan
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    jenis: {
      type: String,
      default: 'bukti',
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      berkas: {},
      dialog: false,
      loading: false,
    };
  },
  methods: {
    open() {
      this.dialog = true;
      this.reset();
      this.stopLoading();
    },

    close() {
      this.dialog = false;
    },

    reset() {
      this.$set(this, 'berkas', {});
    },

    startLoading() {
      this.loading = true;
    },

    stopLoading() {
      this.loading = false;
    },

    onHandleClickAppend() {
      this.$refs[`vFileInput`][0].$el.querySelector('input').click();
    },

    onSave() {
      this.$emit('upload', this.berkas);
    },
  },
};
</script>
